import templateKit from '../assets/images/accueil6.webp';

const templateProduct = {
  _id: 'template-kit',
  name: "Maillot domicile 2025 – Édition Rouge & Jaune",
  description: 'Série spéciale en hommage au carré VIP de Bafang. Respirant, coupe athlétique, badge premium brodé.',
  price: 79,
  collection: "MPA'CHI",
  image: templateKit
};

export default templateProduct;
